import { Component } from "solid-js";

interface FitnessIconProps {
  class?: string;
}

export const FitnessIcon: Component<FitnessIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6372 9.84595L22.1535 13.3622L13.3619 22.1538L9.84562 18.6375L18.6372 9.84595Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.39576 15.2961C4.97811 14.7137 5.92228 14.7137 6.50463 15.2961L16.7036 25.495C17.286 26.0774 17.2859 27.0216 16.7036 27.6039L16.1753 28.1322C15.5929 28.7146 14.6488 28.7146 14.0664 28.1322L3.86744 17.9333C3.28509 17.3509 3.28509 16.4067 3.86744 15.8244L4.39576 15.2961Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.396 20.5718C4.97835 19.9894 5.92253 19.9894 6.50488 20.5718L11.4295 25.4964C12.0118 26.0787 12.0118 27.0229 11.4295 27.6052L10.9011 28.1335C10.3188 28.7159 9.37461 28.7159 8.79227 28.1335L3.86769 23.209C3.28534 22.6266 3.28533 21.6824 3.86768 21.1001L4.396 20.5718Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.604 16.7047C27.0216 17.287 26.0775 17.287 25.4951 16.7047L15.2962 6.50569C14.7138 5.92334 14.7138 4.97916 15.2962 4.39681L15.8245 3.8685C16.4068 3.28615 17.351 3.28615 17.9333 3.8685L28.1323 14.0675C28.7147 14.6498 28.7147 15.594 28.1323 16.1763L27.604 16.7047Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.6045 11.4282C27.0221 12.0105 26.078 12.0105 25.4956 11.4282L20.571 6.50359C19.9887 5.92124 19.9887 4.97706 20.571 4.39471L21.0993 3.86639C21.6817 3.28404 22.6259 3.28404 23.2082 3.86639L28.1328 8.79097C28.7152 9.37332 28.7152 10.3175 28.1328 10.8999L27.6045 11.4282Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
